import { buildUrl } from '../../common/urlBuilder';
import Service from '../../service';

export const getAll = async (filteredData) => {
  let url = buildUrl('v1/room-rate');
  if (filteredData) url += `?${filteredData}`;

  return Service.get(url);
};

export const findById = async (id) => {
  let url = buildUrl(`v1/room-rate/${id}`);

  return Service.get(url);
};

export const create = async (data) => {
  let url = buildUrl('v1/room-rate');
  
  return Service.post(url, data);
};

export const createInventory = async (data) => {
  let url = buildUrl('v1/room-rate/inventory');

  return Service.post(url, data);
};

export const updateRoomRate = async (data) => {
  let url = buildUrl('v1/room-rate/update-rates');

  return Service.post(url, data);
};

export const createRestriction = async (data) => {
  let url = buildUrl('v1/room-rate/restrictions');

  return Service.post(url, data);
};

export const update = async (data, id) => {
  let url = buildUrl(`v1/room-rate/${id}`);
  return Service.put(url, data);
};

export const deleteRatePlan = async (id) => {
  let url = buildUrl(`v1/room-rate/${id}`);
  return Service.delete(url);
};

export const roomType = async (filteredData) =>{
  let url = buildUrl(`v1/room-management/room/`);
  if (filteredData) url += `?${filteredData}`;
  return Service.get(url);
}